import "./src/styles/global.css"

// Scroll to an element matching the current URL hash (e.g. `/school-partnerships#partners`).
const scrollToHash = hash => {
  if (!hash) return false
  const id = decodeURIComponent(hash.replace(/^#/, ""))
  if (!id) return false
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" })
    return true
  }
  return false
}

// Storyblok content can render after the route update, so retry briefly until the
// target exists (or we give up after ~2s).
const scrollToHashWithRetry = hash => {
  if (!hash) return
  let attempts = 0
  const attempt = () => {
    if (scrollToHash(hash) || attempts >= 20) return
    attempts += 1
    setTimeout(attempt, 100)
  }
  setTimeout(attempt, 0)
}

// Let our own handler manage scrolling whenever there's a hash, so Gatsby's default
// scroll restoration doesn't fight it by jumping to the top first.
export const shouldUpdateScroll = ({ routerProps }) => {
  return !routerProps?.location?.hash
}

export const onRouteUpdate = ({ location }) => {
  scrollToHashWithRetry(location && location.hash)
}

export const onInitialClientRender = () => {
  // Handle a hash present on first load / hard refresh.
  scrollToHashWithRetry(window.location.hash)
}
